import type { JSX } from 'solid-js';
import { Show } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import { cx } from '../cx';
import type { ClassMap } from './variant';

// One metric: mono label, the value, an optional sub line. `tone="live"` is one
// of the few places the working accent is reachable — a live dot on the label,
// never the value's colour. With `href` the whole tile is the link; hover
// lightens its hairline, nothing lifts or scales.
export type StatTileTone = 'neutral' | 'live' | 'shipped';

export type StatTileProps = {
  readonly label: string;
  readonly value: string;
  readonly sub?: string;
  readonly tone?: StatTileTone;
  /** Decorative glyph beside the label; rendered `aria-hidden`. */
  readonly icon?: JSX.Element;
  readonly href?: string;
};

export const STAT_TILE_TONE_CLASS: ClassMap<StatTileTone> = {
  neutral: 'ui-stat--neutral',
  live: 'ui-stat--live',
  shipped: 'ui-stat--shipped',
};

export function StatTile(props: StatTileProps): JSX.Element {
  return (
    <Dynamic
      component={props.href ? 'a' : 'div'}
      href={props.href}
      class={cx('ui-stat', STAT_TILE_TONE_CLASS[props.tone ?? 'neutral'])}
    >
      <span class="ui-stat__head">
        <span class="ui-stat__label">{props.label}</span>
        <Show when={props.icon}>
          <span class="ui-stat__icon" aria-hidden="true">
            {props.icon}
          </span>
        </Show>
      </span>
      <span class="ui-stat__value">{props.value}</span>
      <Show when={props.sub}>
        <span class="ui-stat__sub">{props.sub}</span>
      </Show>
    </Dynamic>
  );
}
